import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useAuth } from '@/src/components/AuthContextProvider'
import { SpinnerOverlay } from '@/src/components/SpinnerOverlay'
import { RapidEntryPage } from '@/src/routes/_manage/manage/drawings/rapid'

export const Route = createFileRoute('/create')({
  component: CreateRoute,
})

function CreateRoute() {
  const { status, isAuthenticated } = useAuth()

  useEffect(() => {
    if (status === 'loading') return

    if (!isAuthenticated) {
      const callbackUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`
      window.location.href = `/login?callbackUrl=${encodeURIComponent(callbackUrl)}`
      return
    }

    // authenticated users stay on /create
  }, [status, isAuthenticated])

  if (status === 'loading') {
    return <SpinnerOverlay />
  }

  if (!isAuthenticated) {
    return null
  }

  return <RapidEntryPage />
}
